import { deepEquals } from 'app/infrastructure/js';
import { CompareFieldsData, ExternalUrlGroupItem } from '../types-store';
import { ExternalUrlFormIds } from 'app/area/external-url-groups/form/constants';

export const hasChanges = (item?: ExternalUrlGroupItem, original?: ExternalUrlGroupItem): boolean => {

  const compare = item?.id !== original?.id ||
    item?.description !== original?.description ||
    item?.sequence !== original?.sequence ||
    item?.disabled?.getTime() !== original?.disabled?.getTime() ||
    compareFields({
      fields: [
        ExternalUrlFormIds.caseType,
        ExternalUrlFormIds.operation
      ],
      values: item?.accessPolicy,
      originalValues: original?.accessPolicy
    }) ||
    compareFields({
      fields: [
        ExternalUrlFormIds.urlTemplate
      ],
      values: item?.externalUrls,
      originalValues: original?.externalUrls
    });

  if (compare) {
    return true;
  }

  const language = ((item ?? {}).language ?? [])
    .filter(languageItem => (languageItem.description ?? '').trim().length > 0);
  const originalLanguage = ((original || {}).language || [])
    .filter(languageItem => (languageItem.description ?? '').trim().length > 0);

  if (language.length !== originalLanguage.length) {
    return true;
  }

  if (language.some(
    languageItem => !originalLanguage.some(
      originalLanguageItem => (languageItem.value ?? '') === (originalLanguageItem.value ?? '') &&
        (languageItem.description ?? '') === (originalLanguageItem.description ?? ''))
  )) {
    return true;
  }

  const longDescription = ((item ?? {}).longDescription ?? [])
    .filter(longDescriptionItem => (longDescriptionItem.description ?? '').trim().length > 0);
  const originallongDescription = ((original || {}).longDescription || [])
    .filter(longDescriptionItem => (longDescriptionItem.description ?? '').trim().length > 0);

  if (longDescription.length !== originallongDescription.length) {
    return true;
  }

  if (longDescription.some(
    longDescriptionItem => !originallongDescription.some(
      originalLongDescriptionItem => (longDescriptionItem.value ?? '') === (originalLongDescriptionItem.value ?? '') &&
        (longDescriptionItem.description ?? '') === (originalLongDescriptionItem.description ?? ''))
  )) {
    return true;
  }

  return false;
};

export const compareFields = <T>(data: CompareFieldsData<T>) => {
  const { fields, values, originalValues } = data;

  const newValues = values?.filter(value =>
    fields
      .map(field => value[field])
      .some(item => !!item) && value);

  return !deepEquals(newValues, originalValues);
};
